<script>
export default {
    name: 'BrandLogo',
}
</script>
<template>
    <svg
        class="base-brand brand-logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29 32"
    >
        <g fill="none" fill-rule="evenodd">
            <path fill="currentColor" d="M0 32L29 32 29 0 0 0z" />
            <path
                fill="#303232"
                d="M12.693 16.862v-4.344c0-1 .808-1.812 1.805-1.812.998 0 1.806.813 1.806 1.812v4.344h-3.611zM14.498 6C10.908 6 8 8.92 8 12.518V27h4.693v-5.794h3.61V27H21V12.518C21 8.92 18.089 6 14.498 6z"
            />
        </g>
    </svg>
</template>
